import { useEffect } from "react";

type HookInterface = (asyncHandler: () => Promise<void>, deps?: any[]) => void;

export const useEffectAsync: HookInterface = (asyncHandler, deps) => {
  useEffect(() => {
    asyncHandler();
  }, deps);
};
